module.exports = __webpack_public_path__ + "img/clipboard-solid.79635c7b.svg";